import '../pages/Chatbot.css';
import icon_plus from '../assets/icon_plus.svg';
import Send from '../assets/Send.svg';
import mic_none from '../assets/mic_none.svg';
import Group from '../assets/Group.svg';
import Icon_Group from '../assets/Icon Group.svg';
import Bar from '../assets/Bar.svg';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Search from '../assets/Search.svg';
import Edit from '../assets/Edit.svg';
import Copy from '../assets/Copy.svg';
import Refresh from '../assets/Refresh.svg';
import api from '../pages/api.json'
import Amethyst_Logo from '../assets/Amethyst Logo.svg';
import Mask_Group from '../assets/Mask group.svg';
import Grey_indicator from '../assets/Grey Indicator.svg';
import Thumbs_down from '../assets/Thumbs Down.svg';
import Thumbs_up from '../assets/Thumbs Up.svg';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import TextareaAutosize from 'react-textarea-autosize';
import Cross from '../assets/x-lg.svg';
import Correct from '../assets/check-lg.svg';
import { FiMoreVertical } from 'react-icons/fi';
import { FaFileAlt, FaFileExcel, FaFileImage, FaFilePdf, FaFileWord } from 'react-icons/fa';
import Charts from './CustomMultiSelect';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import Plot from 'react-plotly.js';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';

const user_session_id = uuidv4();

function Chatbotjs({ resetTrigger, messages, setMessages, searchTerm, setSearchTerm, token, username, initialQuery }) {
    const hasSentInitialQuery = useRef(false);

    const location = useLocation();
    const state = location.state;
    console.log(state)

    useEffect(() => {
        if (initialQuery && !hasSentInitialQuery.current && messages.length === 0) {
            console.log("Sending initial query once:", initialQuery);
            handleInitialQuerySend(initialQuery);
            hasSentInitialQuery.current = true; // prevent future sends
        }
    }, [initialQuery]);

    const handleInitialQuerySend = async (query) => {
        if (!query) return;

        const newMessage = {
            text: query,
            files: [],
            isLoading: true,
            response: null,
        };
        setMessages(prev => [...prev, newMessage]);

        // const payload = {
        //     operation: "query",
        //     query,
        //     user_session_id: user_session_id,
        // };

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", query);
        formData.append("user_session_id", user_session_id);


        // Append files (if they exist)
        if (files && files.length > 0) {
            files.forEach((file) => {
                formData.append("file", file);
            });
        }
        console.log(formData)
        try {
            // const streamFetch = fetch(streamDev, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(payload),
            // });

            const queryFetch = fetch(queryDev, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    // "Content-Type": "application/json",
                },
                body: formData,
            });

            // streamFetch.then(async (streamRes) => {
            //     if (!streamRes.body) throw new Error('No response body from stream');
            //     const reader = streamRes.body.getReader();
            //     const decoder = new TextDecoder('utf-8');
            //     let result = "";

            //     while (true) {
            //         const { done, value } = await reader.read();
            //         if (done) break;
            //         const chunk = decoder.decode(value, { stream: true });
            //         result += chunk;

            //         const lines = result.split('\n');
            //         result = lines.pop();

            //         const cleanedLines = lines
            //             .filter(line => line && !line.startsWith('data: [DONE]'))
            //             .map(line => line.replace(/^data:\s*/, ''));

            //         setLogLines(prev => [...prev, ...cleanedLines]);
            //     }
            //     setIsStreaming(false);
            // }).catch(err => {
            //     console.error("Streaming error:", err);
            //     setIsStreaming(false);
            // });

            const queryRes = await queryFetch;
            const data = await queryRes.json();

            setMessages(prev =>
                prev.map((msg, index) =>
                    index === prev.length - 1
                        ? { ...msg, isLoading: false, response: data }
                        : msg
                )
            );
        } catch (error) {
            console.error("Parallel Stream+Query Error:", error);
            setMessages(prev =>
                prev.map((msg, index) =>
                    index === prev.length - 1
                        ? { ...msg, isLoading: false, response: { answer: "Error occurred." } }
                        : msg
                )
            );
            // setIsStreaming(false);
        }
    };

    useEffect(() => {
        console.log("Messages updated:", messages);
    }, [messages]);
    useEffect(() => {
        // Could be a callback to notify parent of layout update
        window.dispatchEvent(new Event('resize'));
    }, []);
    //file upload 1
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [previewURLs, setPreviewURLs] = useState({});
    const [showOptionsIndex, setShowOptionsIndex] = useState(null);

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const newFiles = [...files];
        const newPreviews = { ...previewURLs };

        selectedFiles.forEach(file => {
            if (!newFiles.find(f => f.name === file.name && f.size === file.size)) {
                newFiles.push(file);
                if (file.type.startsWith("image/")) {
                    newPreviews[file.name] = URL.createObjectURL(file);
                }
            }
        });

        setFiles(newFiles);
        setPreviewURLs(newPreviews);

        // Reset input to allow re-uploading same file
        event.target.value = '';
    };

    const excelMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "application/csv"
    ];

    const renderFileIcon = (file) => {
        const type = file.type;
        if (type === "application/pdf") return <FaFilePdf className="text-red-600 text-3xl" />;
        if (type.startsWith("image/")) return <FaFileImage className="text-blue-500 text-3xl" />;
        if (type.includes("word")) return <FaFileWord className="text-blue-600 text-3xl" />;
        if (excelMimeTypes.includes(type)) return <FaFileExcel className="text-[#21A366] text-3xl" />;
        if (type.includes("text")) return <FaFileAlt className="text-gray-600 text-3xl" />;
        return <FaFileAlt className="text-gray-600 text-3xl" />;
    };

    const handleRemoveFile = (index) => {
        const newFiles = [...files];
        const removedFile = newFiles.splice(index, 1)[0];
        setFiles(newFiles);

        const newPreviews = { ...previewURLs };
        delete newPreviews[removedFile.name];
        setPreviewURLs(newPreviews);

        if (showOptionsIndex === index) {
            setShowOptionsIndex(null);
        }
    };

    //speech recognition
    const textareaRef = useRef(null);
    const [isListening, setIsListening] = useState(false);
    const handleMicClick = () => {
        if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
            alert("Speech recognition not supported in this browser.");
            return;
        }

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();

        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = 'en-US';

        recognition.onstart = () => {
            setIsListening(true);
            console.log("Voice recognition started...");

            if (textareaRef.current) {
                textareaRef.current.value = '';
            }
        };

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            console.log("Voice input:", transcript);

            if (textareaRef.current) {
                textareaRef.current.value = transcript; // Only the new one
            }
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error", event);
        };

        recognition.onend = () => {
            setIsListening(false);
            console.log("Voice recognition stopped.");
        };

        recognition.start();
    };
    //submit and query api
    const queryDev = api.queryDev;
    const streamDev = api.queryDevStream;
    const handleSend = async (customQuery) => {
        const value = customQuery || textareaRef.current?.value.trim();
        if (!value && files.length === 0) return;

        // Add message with loading state
        const newMessage = { text: value, files: [...files], isLoading: true, response: null };
        setMessages(prev => [...prev, newMessage]);
        setFiles([]);
        if (!customQuery && textareaRef.current) textareaRef.current.value = "";

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", value);
        formData.append("user_session_id", user_session_id);

        // Append files (if they exist)
        if (files && files.length > 0) {
            files.forEach((file) => {
                formData.append("file", file);
            });
        }

        try {
            const res = await fetch(queryDev, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    // "Content-Type": "application/json",
                },
                body: formData,
            });
            console.log(formData)
            const data = await res.json();

            // Update only the last message with the response
            setMessages(prev =>
                prev.map((msg, index) =>
                    index === prev.length - 1
                        ? { ...msg, isLoading: false, response: data }
                        : msg
                )
            );
        } catch (error) {
            console.error(error);
            setMessages(prev =>
                prev.map((msg, index) =>
                    index === prev.length - 1
                        ? { ...msg, isLoading: false, response: { answer: "Error occurred." } }
                        : msg
                )
            );
        }
    };
    const [logLines, setLogLines] = useState([]);
    const [isStreaming, setIsStreaming] = useState(false);
    const [log, setLog] = useState([]);
    // const handleSend = async (customQuery) => {
    //     const value = customQuery || textareaRef.current?.value.trim();
    //     if (!value && files.length === 0) return;

    //     const newMessage = {
    //         text: value,
    //         files: [...files],
    //         isLoading: true,
    //         response: null,
    //     };
    //     setMessages(prev => [...prev, newMessage]);
    //     setFiles([]);
    //     if (!customQuery && textareaRef.current) textareaRef.current.value = "";

    //     const payload = {
    //         operation: "query",
    //         query: value,
    //         user_session_id: user_session_id
    //     };

    //     setLog('');
    //     setIsStreaming(true);
    //     setLogLines([])

    //     try {
    //         // --- Start both API calls at the same time ---
    //         const streamFetch = fetch(streamDev, {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(payload),
    //         });

    //         const queryFetch = fetch(queryDev, {
    //             method: "POST",
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(payload),
    //         });

    //         // --- Handle streaming logs independently ---
    //         streamFetch.then(async (streamRes) => {
    //             if (!streamRes.body) throw new Error('No response body from stream');
    //             const reader = streamRes.body.getReader();
    //             const decoder = new TextDecoder('utf-8');
    //             let result = "";

    //             while (true) {
    //                 const { done, value } = await reader.read();
    //                 if (done) break;

    //                 const chunk = decoder.decode(value, { stream: true });
    //                 result += chunk;

    //                 const lines = result.split('\n');
    //                 result = lines.pop(); // Save the last incomplete line for the next read

    //                 const cleanedLines = lines
    //                     .filter(line => line && !line.startsWith('data: [DONE]'))
    //                     .map(line => line.replace(/^data:\s*/, ''));

    //                 setLogLines(prev => [...prev, ...cleanedLines]);
    //                 // setLog(cleaned);
    //             }

    //             setIsStreaming(false);
    //         }).catch((err) => {
    //             console.error("Streaming error:", err);
    //             setIsStreaming(false);
    //         });
    //         // --- Handle query response ---
    //         const queryRes = await queryFetch;
    //         const data = await queryRes.json();

    //         setMessages(prev =>
    //             prev.map((msg, index) =>
    //                 index === prev.length - 1
    //                     ? { ...msg, isLoading: false, response: data }
    //                     : msg
    //             )
    //         );
    //     } catch (error) {
    //         console.error("Parallel Stream+Query Error:", error);
    //         setMessages(prev =>
    //             prev.map((msg, index) =>
    //                 index === prev.length - 1
    //                     ? { ...msg, isLoading: false, response: { answer: "Error occurred." } }
    //                     : msg
    //             )
    //         );
    //         setIsStreaming(false);
    //     }
    // };




    //clickable text

    const handleAutoTextClick = (text) => {
        if (textareaRef.current) {
            textareaRef.current.value = text;
            textareaRef.current.focus();
        }
    };
    //copy
    const [copied, setCopied] = useState(false);

    const handleCopy = async (msg) => {
        let textToCopy = '';

        if (typeof msg === 'string') {
            textToCopy = msg;
        } else if (typeof msg === 'object') {
            // Check for possible keys
            if (msg.text) {
                textToCopy = msg.text;
            } else if (msg.answer) {
                textToCopy = msg.answer;
            } else if (msg.response?.answer) {
                textToCopy = msg.response.answer;
            }
        }

        if (!textToCopy) {
            console.warn('Nothing to copy');
            return;
        }

        try {
            await navigator.clipboard.writeText(textToCopy);
            console.log('Copied:', textToCopy);
            setCopied(true); // show popup
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error('Copy failed:', err);
        }
    };

    // edit
    const [editIndex, setEditIndex] = useState(null);
    const [editText, setEditText] = useState('');
    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditText(messages[index].text);
    };
    const handleSaveEdit = async () => {
        if (editIndex === null) return;

        const updatedText = editText.trim();
        if (!updatedText) return;

        setEditIndex(null);
        setEditText('');

        const newMessage = { text: updatedText, isLoading: true, response: null };
        setMessages(prev => [...prev, newMessage]);

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", updatedText);
        formData.append("user_session_id", user_session_id);

        // Append files (if they exist)
        // if (files && files.length > 0) {
        //     files.forEach((file) => {
        //         formData.append("file", file);
        //     });
        // }
        // const payload = {
        //     operation: "query",
        //     query: updatedText,
        //     user_session_id: user_session_id,
        // };

        // setLog('');
        // setIsStreaming(true);
        // setLogLines([]);

        try {
            // const streamFetch = fetch(streamDev, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(payload),
            // });

            const queryFetch = fetch(queryDev, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    // "Content-Type": "application/json",
                },
                body: formData,
            });

            // streamFetch.then(async (streamRes) => {
            //     if (!streamRes.body) throw new Error('No response body from stream');
            //     const reader = streamRes.body.getReader();
            //     const decoder = new TextDecoder('utf-8');
            //     let result = "";

            //     while (true) {
            //         const { done, value } = await reader.read();
            //         if (done) break;
            //         const chunk = decoder.decode(value, { stream: true });
            //         result += chunk;

            //         const lines = result.split('\n');
            //         result = lines.pop();

            //         const cleanedLines = lines
            //             .filter(line => line && !line.startsWith('data: [DONE]'))
            //             .map(line => line.replace(/^data:\s*/, ''));

            //         setLogLines(prev => [...prev, ...cleanedLines]);
            //     }
            //     setIsStreaming(false);
            // }).catch(err => {
            //     console.error("Streaming error:", err);
            //     setIsStreaming(false);
            // });

            const queryRes = await queryFetch;
            const data = await queryRes.json();

            setMessages(prev =>
                prev.map((msg, i) =>
                    i === prev.length - 1
                        ? { ...msg, isLoading: false, response: data }
                        : msg
                )
            );
        } catch (err) {
            console.error("Parallel Stream+Query Error:", err);
            setMessages(prev =>
                prev.map((msg, i) =>
                    i === prev.length - 1
                        ? { ...msg, isLoading: false, response: { answer: "Error occurred." } }
                        : msg
                )
            );
            // setIsStreaming(false);
        }
    };


    const handleCancelEdit = () => {
        setEditIndex(null);
        setEditText('');
    };
    //sidebar collapse
    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };
    //search
    const filteredMessages = messages.filter((msg) => {
        const text = msg.text?.toLowerCase() || "";
        const response = msg.response?.answer?.toLowerCase() || "";
        return text.includes(searchTerm.toLowerCase()) || response.includes(searchTerm.toLowerCase());
    });

    // const filteredMessages = searchTerm.trim()
    //     ? messages.filter((msg) => {
    //         const text = msg.text?.toLowerCase() || "";
    //         const response = msg.response?.answer?.toLowerCase() || "";
    //         return text.includes(searchTerm.toLowerCase()) || response.includes(searchTerm.toLowerCase());
    //     })
    //     : messages;



    //new chat
    // const handleNewChat = () => {
    //     setMessages([]);
    //     setSearchTerm('');
    //     setEditIndex(null);
    //     setEditText('');
    //     if (textareaRef.current) {
    //         textareaRef.current.value = '';
    //     }
    // };
    //on enter key
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault(); // prevent newline
            handleSend();       // call send function
        }
    };
    //scroll at bottom
    const [lastScrolledIndex, setLastScrolledIndex] = useState(-1);
    const bottomRef = useRef(null);
    const [lastScrolledPhase, setLastScrolledPhase] = useState(""); // "text" or "response"

    useEffect(() => {
        if (filteredMessages.length === 0) return;

        const lastIndex = filteredMessages.length - 1;
        const lastMessage = filteredMessages[lastIndex];

        // Phase 1: Scroll on user message (text)
        if (
            lastMessage.text &&
            !lastMessage.response &&
            lastScrolledIndex !== lastIndex
        ) {
            bottomRef.current?.scrollIntoView({ behavior: "smooth" });
            setLastScrolledIndex(lastIndex);
            setLastScrolledPhase("text");
            return;
        }

        // Phase 2: Scroll on bot response
        if (
            lastMessage.response &&
            !lastMessage.isLoading &&
            (lastScrolledIndex !== lastIndex || lastScrolledPhase !== "response")
        ) {
            bottomRef.current?.scrollIntoView({ behavior: "smooth" });
            setLastScrolledIndex(lastIndex);
            setLastScrolledPhase("response");
        }
    }, [filteredMessages]);




    //new chat
    // useEffect(() => {
    //     // Clear conversation and reset input when resetTrigger changes
    //     setMessages([]);
    //     setSearchTerm('');
    //     setEditIndex(null);
    //     setEditText('');
    //     if (textareaRef.current) {
    //         textareaRef.current.value = '';
    //     }
    // }, [resetTrigger]);
    //refresh
    const handleRefreshClick = async (index) => {
        const originalMsg = filteredMessages[index];
        if (!originalMsg?.text) return;

        const value = originalMsg.text;

        const newMessage = { text: value, isLoading: true, response: null };
        setMessages(prev => [...prev, newMessage]);

        // const payload = {
        //     operation: "query",
        //     query: value,
        //     user_session_id: user_session_id,
        // };
        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", value);
        formData.append("user_session_id", user_session_id);
        // setLog('');
        // setIsStreaming(true);
        // setLogLines([]);

        try {
            // const streamFetch = fetch(streamDev, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(payload),
            // });

            const queryFetch = fetch(queryDev, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    // "Content-Type": "application/json",
                },
                body: formData,
            });

            // streamFetch.then(async (streamRes) => {
            //     if (!streamRes.body) throw new Error('No response body from stream');
            //     const reader = streamRes.body.getReader();
            //     const decoder = new TextDecoder('utf-8');
            //     let result = "";

            //     while (true) {
            //         const { done, value } = await reader.read();
            //         if (done) break;
            //         const chunk = decoder.decode(value, { stream: true });
            //         result += chunk;

            //         const lines = result.split('\n');
            //         result = lines.pop();

            //         const cleanedLines = lines
            //             .filter(line => line && !line.startsWith('data: [DONE]'))
            //             .map(line => line.replace(/^data:\s*/, ''));

            //         setLogLines(prev => [...prev, ...cleanedLines]);
            //     }
            //     setIsStreaming(false);
            // }).catch(err => {
            //     console.error("Streaming error:", err);
            //     setIsStreaming(false);
            // });

            const queryRes = await queryFetch;
            const data = await queryRes.json();

            setMessages(prev =>
                prev.map((msg, i) =>
                    i === prev.length - 1
                        ? { ...msg, isLoading: false, response: data }
                        : msg
                )
            );
        } catch (error) {
            console.error("Parallel Stream+Query Error:", error);
            setMessages(prev =>
                prev.map((msg, i) =>
                    i === prev.length - 1
                        ? { ...msg, isLoading: false, response: { answer: "Error occurred." } }
                        : msg
                )
            );
            // setIsStreaming(false);
        }
    };

    //cost breakdown text

    // const handleDeepDiveQuery = (type) => {
    //     const queryMap = {
    //         'Raw Material': 'Display the following for Raw Material: 1) Raw Material Specs 2) Cost breakdown(Raw Material, Net Vol., Density, Net Wt., Price, Total RM ) 3) Ancillary Costs if 4) Key Insights in 3 Bullet Points(RM Share in total cost, Major RM Cost Driver, Material Utilization)',
    //         'Processing': 'Display the following for Manufacturing: 1) Feature - Process Map : In Tabular Format 2) Process - Time - Cost Table (display 1 decimal place for time) : Tabular Format 3) Key Insights in three bullet points - (Largest Process Cost, Set up cost impact and MHR related)',
    //         'Overheads': 'Display the following for Overheads 1) Overheads cost components only : In Tabular Format 2) Benchmarks if any in tabular format 3) Do not display any more information',
    //     };

    //     const query = queryMap[type];
    //     if (query) {
    //         handleSend(query);
    //     }
    // };

    const allButtons = ['Raw Material', 'Processing', 'Overheads'];
    // const [lastClicked, setLastClicked] = React.useState(null);
    const [responseText, setResponseText] = React.useState('');

    const queryMap = {
        'Raw Material': 'Display the following for Raw Material: 1) Raw Material Specs 2) Cost breakdown(Raw Material, Net Vol., Density, Net Wt., Price, Total RM ) 3) Ancillary Costs if 4) Key Insights in 3 Bullet Points(RM Share in total cost, Major RM Cost Driver, Material Utilization)',
        'Processing': 'Display the following for Manufacturing: 1) Feature - Process Map : In Tabular Format 2) Process - Time - Cost Table (display 1 decimal place for time) : Tabular Format 3) Key Insights in three bullet points - (Largest Process Cost, Set up cost impact and MHR related)',
        'Overheads': 'Display the following for Overheads 1) Overheads cost components only : In Tabular Format 2) Benchmarks if any in tabular format 3) Do not display any more information',
    };

    // const handleDeepDiveQuery = (type) => {
    //     setLastClicked(type);
    //     setResponseText(`Response for ${type} goes here...`); // or real response from API
    //     const query = queryMap[type];
    //     if (query) {
    //         handleSend(query);
    //     }
    // };
    const [lastClicked, setLastClicked] = React.useState(null);
    const [isDeepDiveResponse, setIsDeepDiveResponse] = React.useState(false);

    // called when user clicks a deep dive button
    const handleDeepDiveQuery = (type) => {
        // your query logic here...
        setLastClicked(type);
        setIsDeepDiveResponse(true);
        handleSend(queryMap[type]);
    };

    // called when user does a normal query (not deep dive)
    const handleNormalQuery = (query) => {
        setLastClicked(null);
        setIsDeepDiveResponse(false);
        handleSend(query);
    };

    return (

        <div className="container-fluid">
            <div className='row'>
                <div className='col-12 p-0'>
                    <div className='chatbot-screen w-full'>
                        <div className='w-full'>
                            {/* {filteredMessages.length > 0 && ( */}
                            <div className="overflow-y-auto h-[72vh] z-0 mid-xl:!h-[80vh]">
                                {filteredMessages.map((msg, index) => (
                                    <div key={index}>
                                        <div className='chatbot-message pr-16 pl-16 w-full mid-xl:!pr-32 mid-xl:!pl-32'>
                                            <div className="flex flex-col items-end w-[80%]">
                                                {(typeof msg.text === "string" && msg.text.trim()) && (
                                                    <div className="chatbot-one">
                                                        <div className="chatbot-outertext">
                                                            {editIndex === index ? (
                                                                <div>
                                                                    <TextareaAutosize
                                                                        value={editText}
                                                                        onChange={(e) => setEditText(e.target.value)}
                                                                        className="w-[40ch] border rounded px-2 py-1 outline-none resize-none mid-xl:!text-2xl mid-l:!text-lg"
                                                                        minRows={1}
                                                                        maxRows={6}
                                                                    />
                                                                    <div className="flex justify-end gap-2">
                                                                        <button onClick={handleSaveEdit} className="text-gray-500 text-sm mid-xl:!text-xl">Save</button>
                                                                        <button onClick={handleCancelEdit} className="text-gray-500 text-sm mid-xl:!text-xl">Cancel</button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="chatbot-messageText mid-xl:!text-2xl mid-l:!text-lg">{msg.text}</div>
                                                            )}
                                                        </div>
                                                    </div>)}
                                                {copied && (
                                                    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-[#e6dcff] text-black px-4 py-2 rounded shadow-sm z-50 transition-opacity">
                                                        Copied to clipboard!
                                                    </div>
                                                )}

                                                {editIndex !== index && typeof msg.text === "string" && msg.text.trim() && (
                                                    <div className="chatbot-icons flex gap-2 pr-2">
                                                        <div className="tooltip-container1">
                                                            <img
                                                                src={Edit}
                                                                alt="Edit"
                                                                className="Edit cursor-pointer"
                                                                onClick={() => handleEditClick(index)}
                                                            />
                                                            <span className="tooltip-text1">Edit</span>
                                                        </div>

                                                        <div className="tooltip-container1">
                                                            <img
                                                                src={Copy}
                                                                alt="Copy"
                                                                className="Copy cursor-pointer"
                                                                onClick={() => handleCopy(msg)}
                                                            />
                                                            <span className="tooltip-text1">Copy</span>
                                                        </div>

                                                        <div className="tooltip-container1">
                                                            <img
                                                                src={Refresh}
                                                                alt="Refresh"
                                                                className="Refresh cursor-pointer"
                                                                onClick={() => handleRefreshClick(index)}
                                                            />
                                                            <span className="tooltip-text1">Refresh</span>
                                                        </div>
                                                    </div>
                                                )}

                                                {msg.files?.length > 0 && (
                                                    <div className="flex gap-1 flex-wrap mt-2">
                                                        {msg.files.map((file, i) => (
                                                            <div key={file.name + i} className="chatbotFile ...">
                                                                {renderFileIcon(file)}
                                                                <span className="font-semibold truncate max-w-[120px]">{file.name}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='pl-16 pr-16 w-full mid-xl:!pl-32 mid-xl:!pr-32'>
                                            {msg.isLoading ? (
                                                // <div className="chatbot-response pb-8 ">
                                                //     <div>
                                                //         <img src={Amethyst_Logo} alt="Amethyst_Logo" className="Amethyst_Logo" />
                                                //     </div>
                                                //     <div className='chatbot-responseright flex flex-row'>
                                                //         <span className='chatbot-loaderImg pt-2'>
                                                //             <span className="relative inline-block w-8 h-8">
                                                //                 <img
                                                //                     src={Mask_Group}
                                                //                     alt="Mask_Group"
                                                //                     className="Mask_Group absolute top-0 left-0 w-full h-full animate-spin"
                                                //                 />
                                                //                 <img
                                                //                     src={Grey_indicator}
                                                //                     alt="Grey_indicator"
                                                //                     className="Grey_indicator absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
                                                //                 />
                                                //             </span>
                                                //         </span>
                                                //         <span className='chatbot-responsetext pt-2 mid-xl:!text-2xl mid-l:!text-lg'>
                                                //             {logLines.length > 0 && (() => {
                                                //                 const line = logLines[logLines.length - 1];

                                                //                 const extractText = (rawLine) => {
                                                //                     try {
                                                //                         let trimmed = rawLine.trim();
                                                //                         if (trimmed.startsWith('data:')) {
                                                //                             trimmed = trimmed.slice(5).trim();
                                                //                         }
                                                //                         const match = trimmed.match(/['"]text['"]\s*:\s*['"]([\s\S]*?)['"]/);
                                                //                         if (match && match[1] !== undefined) {
                                                //                             return match[1].replace(/\\n/g, '\n');
                                                //                         }
                                                //                     } catch { }
                                                //                     return rawLine;
                                                //                 };

                                                //                 const cleanText = extractText(line);

                                                //                 return (
                                                //                     <ReactMarkdown
                                                //                         remarkPlugins={[remarkGfm]}
                                                //                         rehypePlugins={[rehypeRaw]}
                                                //                         components={{
                                                //                             h1: ({ node, ...props }) => <h1 className="font-bold text-xs mt-4 mb-2" {...props} />,
                                                //                             h2: ({ node, ...props }) => <h2 className="font-bold text-xs mt-4 mb-2" {...props} />,
                                                //                             h3: ({ node, ...props }) => <h3 className="font-bold text-xs mt-3 mb-1" {...props} />,
                                                //                             table: ({ node, ...props }) => <table className="table-auto border-collapse border border-gray-400 my-4" {...props} />,
                                                //                             th: ({ node, ...props }) => <th className="text-xs border !border-gray-300 bg-[rgba(230,220,255,1)] px-1 py-1 text-left" {...props} />,
                                                //                             td: ({ node, ...props }) => <td className="text-xs border border-gray-300 px-1 py-1" {...props} />,
                                                //                             ul: ({ node, ...props }) => <ul className="text-xs list-disc ml-6" {...props} />,
                                                //                             ol: ({ node, ...props }) => <ol className="text-xs list-decimal ml-6" {...props} />,
                                                //                             li: ({ node, ...props }) => <li className="text-xs mb-1" {...props} />,
                                                //                         }}
                                                //                     >
                                                //                         {cleanText || 'Thinking..'}
                                                //                     </ReactMarkdown>
                                                //                 );
                                                //             })()}
                                                //         </span>


                                                //     </div>
                                                // </div>


                                                <div className='chatbot-loader'>
                                                    <div className='chatbot-loaderInside'>
                                                        <img src={Amethyst_Logo} alt="Amethyst_Logo" className="Amethyst_Logo" />
                                                        <span className='chatbot-loaderImg'>
                                                            <span className="relative inline-block w-8 h-8">
                                                                <img
                                                                    src={Mask_Group}
                                                                    alt="Mask_Group"
                                                                    className="Mask_Group absolute top-0 left-0 w-full h-full animate-spin"
                                                                />
                                                                <img
                                                                    src={Grey_indicator}
                                                                    alt="Grey_indicator"
                                                                    className="Grey_indicator absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
                                                                />
                                                            </span>
                                                            <span className='chatbot-loadertext'>Processing… this may take a moment.</span>
                                                        </span>
                                                    </div>

                                                </div>
                                            ) : (msg.response && (
                                                <div className="chatbot-response pb-8 ">
                                                    <div>
                                                        <img src={Amethyst_Logo} alt="Amethyst_Logo" className="Amethyst_Logo" />
                                                    </div>
                                                    <div className='chatbot-responseright'>
                                                        <span className='chatbot-responsetext'
                                                            style={{
                                                                background: 'linear-gradient(135deg, #e0d7f5, #f7f3fc)',  // soft purple gradient
                                                                padding: '20px',
                                                                borderRadius: '16px',
                                                                // boxShadow: '0 4px 12px rgba(70, 0, 115, 0.15)',  // subtle purple shadow
                                                                display: 'block',
                                                                // marginBottom: '20px',
                                                            }}>

                                                            {(() => {
                                                                const answer = msg?.response?.answer;

                                                                // 1. JSON directly
                                                                if (typeof answer === 'object' && answer !== null && !Array.isArray(answer)) {
                                                                    return (
                                                                        <Plot
                                                                            data={answer.data}
                                                                            layout={answer.layout}
                                                                            config={{ responsive: true }}
                                                                            style={{ width: '100%', height: '100%' }}
                                                                        />
                                                                    );
                                                                }

                                                                // 2. JSON as string inside code block
                                                                if (typeof answer === 'string') {
                                                                    const looseMatch = answer.match(/```(?:json)?\s*([\s\S]*?)\s*```/); // even works without `json`
                                                                    if (looseMatch) {
                                                                        try {
                                                                            const plotJson = JSON.parse(looseMatch[1]);
                                                                            const parts = answer.split(looseMatch[0]);
                                                                            const beforeChartText = parts[0]?.trim();
                                                                            const afterChartText = parts[1]?.trim();
                                                                            const barThickness = 60;
                                                                            const numberOfBars = plotJson.data?.[0]?.x?.length || 1; // safer for horizontal bars
                                                                            const width = numberOfBars * barThickness + 100;
                                                                            const enhancedLayout = {
                                                                                ...plotJson.layout,
                                                                                title: {
                                                                                    text: plotJson.layout?.title,
                                                                                    x: 0.1,
                                                                                    xanchor: "left",
                                                                                    font: {
                                                                                        color: "#460073",
                                                                                        size: 14
                                                                                    },
                                                                                },

                                                                                xaxis: {
                                                                                    // title: '',
                                                                                    ...plotJson.layout?.xaxis,
                                                                                    tickfont: { size: 13 },
                                                                                    tickangle: -30,
                                                                                    ticks: "outside",
                                                                                    automargin: true,
                                                                                    // showticklabels: false
                                                                                },

                                                                                showlegend: false,
                                                                                margin: { l: 50, r: 50, t: 50, b: 100 }, // leave enough margins for labels, etc
                                                                                autosize: true,
                                                                                height: '100%',
                                                                                annotations: [],
                                                                            };

                                                                            const enhancedData = plotJson.data.map(trace => ({
                                                                                ...trace,
                                                                                textposition: 'outside',
                                                                                decreasing: { marker: { color: "#5C2957" } },
                                                                                increasing: { marker: { color: "#A97CDA" } },
                                                                                totals: { marker: { color: "#460073" } },
                                                                                connector: {
                                                                                    line: {
                                                                                        color: 'rgba(207, 207, 207, 1)',
                                                                                        width: 2,
                                                                                    },
                                                                                },
                                                                            }));
                                                                            return (
                                                                                <>
                                                                                    {beforeChartText && (
                                                                                        <ReactMarkdown
                                                                                            remarkPlugins={[remarkGfm]}
                                                                                            rehypePlugins={[rehypeRaw]}
                                                                                            components={{
                                                                                                h1: ({ node, ...props }) => <h1 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                                h2: ({ node, ...props }) => <h2 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                                h3: ({ node, ...props }) => <h3 className="font-bold text-sm mt-3 mb-1" {...props} />,
                                                                                                table: ({ node, ...props }) => (
                                                                                                    <table className="table-auto bg-[#fff] border-collapse border border-gray-800 my-4" {...props} />
                                                                                                ),
                                                                                                th: ({ node, ...props }) => (
                                                                                                    <th className="text-sm border !border-gray-800 text-[#fff] bg-[#460073] px-1 py-1 text-left" {...props} />
                                                                                                ),
                                                                                                td: ({ node, ...props }) => (
                                                                                                    <td className="text-[13px] border !border-gray-800 px-1 py-1" {...props} />
                                                                                                ),
                                                                                                ul: ({ node, ...props }) => <ul className="text-[13px] list-disc ml-6" {...props} />,
                                                                                                ol: ({ node, ...props }) => <ol className="text-[13px] list-decimal ml-6" {...props} />,
                                                                                                li: ({ node, ...props }) => <li className="text-[13px] mb-1" {...props} />,
                                                                                            }}
                                                                                        >
                                                                                            {beforeChartText}
                                                                                        </ReactMarkdown>
                                                                                    )}
                                                                                    <Plot
                                                                                        data={enhancedData}
                                                                                        layout={enhancedLayout}
                                                                                        config={{
                                                                                            responsive: false, displaylogo: false, modeBarButtonsToRemove: [
                                                                                                'zoom2d', 'pan2d', 'select2d', 'lasso2d',
                                                                                                'zoomIn2d', 'zoomOut2d', 'autoScale2d',
                                                                                                'resetScale2d', 'hoverClosestCartesian',
                                                                                                'hoverCompareCartesian', 'toggleSpikelines',
                                                                                            ],
                                                                                        }}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            maxWidth: '900px',
                                                                                            wordBreak: 'break-word',
                                                                                            border: '3px solid #460073',  // purple border
                                                                                            borderRadius: '12px',
                                                                                            boxSizing: 'border-box',      // important to include border in width
                                                                                            overflow: 'hidden',           // prevent scrollbars if any tiny overflow
                                                                                        }}
                                                                                    />
                                                                                    {afterChartText && (
                                                                                        <ReactMarkdown
                                                                                            remarkPlugins={[remarkGfm]}
                                                                                            rehypePlugins={[rehypeRaw]}
                                                                                            components={{
                                                                                                h1: ({ node, ...props }) => <h1 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                                h2: ({ node, ...props }) => <h2 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                                h3: ({ node, ...props }) => <h3 className="font-bold text-sm mt-3 mb-1" {...props} />,
                                                                                                table: ({ node, ...props }) => (
                                                                                                    <table className="table-auto bg-[#fff] border-collapse border border-gray-800 my-4" {...props} />
                                                                                                ),
                                                                                                th: ({ node, ...props }) => (
                                                                                                    <th className="text-[14px] border !border-gray-800 text-[#fff] bg-[#460073] px-1 py-1 text-left" {...props} />
                                                                                                ),
                                                                                                td: ({ node, ...props }) => (
                                                                                                    <td className="text-[13px] border !border-gray-800 px-1 py-1" {...props} />
                                                                                                ),
                                                                                                ul: ({ node, ...props }) => <ul className="text-[13px] list-disc ml-6" {...props} />,
                                                                                                ol: ({ node, ...props }) => <ol className="text-[13px] list-decimal ml-6" {...props} />,
                                                                                                li: ({ node, ...props }) => <li className="text-[13px] mb-1" {...props} />,
                                                                                            }}
                                                                                        >
                                                                                            {afterChartText}
                                                                                        </ReactMarkdown>
                                                                                    )}
                                                                                    {plotJson && (
                                                                                        <div className="mt-6">

                                                                                            <div className="text-[14px] font-medium mb-4 text-gray-800">
                                                                                                Do you want me to deep dive into detailed cost breakdown for any component?
                                                                                            </div>
                                                                                            <div className="text-[13px] flex gap-4">
                                                                                                {['Raw Material', 'Processing', 'Overheads'].map((label) => (
                                                                                                    <button
                                                                                                        key={label}
                                                                                                        onClick={() => handleDeepDiveQuery(label)}
                                                                                                        className="bg-[#FFF] h-20 text-[#460073] px-4 py-2 rounded-xl font-semibold hover:bg-[#e4d4ff] transition"
                                                                                                    >
                                                                                                        {label}
                                                                                                    </button>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        } catch (err) {
                                                                            console.error('Plotly JSON parsing error:', err);
                                                                        }
                                                                    }
                                                                }

                                                                // 3. Default: render as Markdown only
                                                                return (
                                                                    <>
                                                                        <ReactMarkdown
                                                                            remarkPlugins={[remarkGfm]}
                                                                            rehypePlugins={[rehypeRaw]}
                                                                            components={{
                                                                                h1: ({ node, ...props }) => <h1 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                h2: ({ node, ...props }) => <h2 className="font-bold text-sm mt-4 mb-2" {...props} />,
                                                                                h3: ({ node, ...props }) => <h3 className="font-bold text-sm mt-3 mb-1" {...props} />,
                                                                                table: ({ node, ...props }) => (
                                                                                    <table className="table-auto bg-[#fff] border-collapse border border-gray-800 my-4" {...props} />
                                                                                ),
                                                                                th: ({ node, ...props }) => (
                                                                                    <th className="text-[14px] border !border-gray-800 text-[#fff] bg-[#460073] px-1 py-1 text-left" {...props} />
                                                                                ),
                                                                                td: ({ node, ...props }) => (
                                                                                    <td className="text-[13px] border !border-gray-800 px-1 py-1" {...props} />
                                                                                ),
                                                                                ul: ({ node, ...props }) => <ul className="text-[13px] list-disc ml-6" {...props} />,
                                                                                ol: ({ node, ...props }) => <ol className="text-[13px] list-decimal ml-6" {...props} />,
                                                                                li: ({ node, ...props }) => <li className="text-[13px] mb-1" {...props} />,
                                                                            }}
                                                                        >
                                                                            {answer || msg?.response?.error || msg?.response?.detail}
                                                                        </ReactMarkdown>
                                                                        {/* {isDeepDiveResponse && lastClicked && (
                                                                            <div className="mt-6">
                                                                                <div className="text-[14px] font-medium mb-4 text-gray-800">
                                                                                    Do you want me to deep dive into detailed cost breakdown for any component?
                                                                                </div>
                                                                                <div className="text-[13px] flex gap-4">
                                                                                    {allButtons
                                                                                        .filter((btn) => btn !== lastClicked)
                                                                                        .map((btn) => (
                                                                                            <button
                                                                                                key={btn}
                                                                                                onClick={() => handleDeepDiveQuery(btn)}
                                                                                                className="bg-[#FFF] h-20 text-[#460073] px-4 py-2 rounded-xl font-semibold hover:bg-[#e4d4ff] transition"
                                                                                            >
                                                                                                {btn}
                                                                                            </button>
                                                                                        ))}
                                                                                </div>
                                                                            </div>
                                                                        )} */}
                                                                    </>
                                                                );
                                                            })()}



                                                        </span>

                                                        <span className='chatbot-responseBorder'>
                                                            <span className='chatbot-borderInside'></span>
                                                        </span>
                                                        <span className='chatbot-likeDislikeButtons'>
                                                            <div className="tooltip-container1">
                                                                <img src={Thumbs_up} alt="Thumbs_up" className="Thumbs_up cursor-pointer" />
                                                                <span className="tooltip-text1">Good Response</span>
                                                            </div>

                                                            <div className="tooltip-container1">
                                                                <img src={Thumbs_down} alt="Thumbs_down" className="Thumbs_down cursor-pointer" />
                                                                <span className="tooltip-text1">Bad Response</span>
                                                            </div>

                                                            <div className="tooltip-container1">
                                                                <img
                                                                    src={Copy}
                                                                    alt="Copy"
                                                                    className="Copy cursor-pointer"
                                                                    onClick={() => handleCopy(msg.response.answer || msg.response.error)}
                                                                />
                                                                <span className="tooltip-text1">Copy</span>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                            )}
                                        </div>
                                    </div>
                                ))}
                                <div ref={bottomRef} />
                            </div>
                            {/* )} */}
                            {/* <div className={`chatbot-inputField mx-auto ${messages.length > 0 ? 'pt-2 fixed bottom-0 left-0 right-0 z-10 pb-14' : 'pt-24'} ${isCollapsed ? 'left-0' : 'left-60'}`}> */}

                            {/* < div className='chatbot-inputField mx-auto pt-2 fixed bottom-0 z-10 pb-14' > */}
                            < div className={` w-auto ml-4 mr-4 bg-white ${files.length > 0 ? 'rounded-none' : 'rounded-full'} !px-[30px] !py-[8px] border !border-[#7500C0]`}>
                                {files.length > 0 && (
                                    <div className="flex gap-1 pb-4 flex-wrap">
                                        {files.map((file, index) => (
                                            <div key={file.name + index} className="chatbotFile justify-between flex items-center space-x-2 relative">
                                                {renderFileIcon(file)}
                                                <span className="font-semibold truncate max-w-[120px]">{file.name}</span>

                                                <div className="relative">
                                                    <FiMoreVertical
                                                        className="cursor-pointer text-gray-600 hover:text-black"
                                                        onClick={() => setShowOptionsIndex(showOptionsIndex === index ? null : index)}
                                                    />
                                                    {showOptionsIndex === index && (
                                                        <div className="absolute right-0 top-6 bg-white border border-gray-300 shadow-md rounded-md z-10">
                                                            <button
                                                                className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-[#E6DCFF]"
                                                                onClick={() => handleRemoveFile(index)}
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="chatbot-textarea w-auto flex items-center">
                                    <span className="shrink-0">
                                        <div className="tooltip-container1">
                                            <img
                                                src={icon_plus}
                                                alt="icon_plus"
                                                className="icon_plus cursor-pointer"
                                                onClick={handleImageClick}
                                            />
                                            <span className="tooltip-text1">Upload File</span>
                                        </div>
                                        <input
                                            type="file"
                                            multiple
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            className="hidden"
                                        />
                                    </span>

                                    {/* Textarea expands fully */}
                                    <TextareaAutosize
                                        minRows={1}
                                        maxRows={4}
                                        ref={textareaRef}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Hi! How may I help you with should costs today?"
                                        className="flex-1 min-w-0 chatbot-textareaInput resize-none z-10"
                                    />

                                    {/* Right-side icons */}
                                    <div className="flex items-center gap-2 shrink-0">
                                        <img src={mic_none} alt="mic" className="mic_none cursor-pointer" onClick={handleMicClick} />
                                        <img src={Send} alt="Send" className="Send cursor-pointer" onClick={() => handleSend()} />
                                    </div>
                                </div>

                            </div>

                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default Chatbotjs;